import { get } from './httpClient'

export const getSummary = (params) => get('/summary', params)
export const getChartRevenue = () => get('/summary/chart')
export const getChartTopSelling = () => get('/summary/topselling')
export const getChartStatus = (params) => get('/summary/status', params)
export const getLastNews = (params) => get('/summary/lastnews', params)
export const getLastProductTypes = (params) =>
  get('/summary/lastproducttype', params)
